import { base64SimpleLabelPDF } from "./simple-warning-label-generation";


export function base64FragileLabelPDF(widthInches: number, heightInches: number, copies: number = 1): string {
  const text = "! FRAGILE !\nHANDLE WITH CARE";

  return base64SimpleLabelPDF({
    widthInches: widthInches,
    heightInches: heightInches,
    text,
    textColor: [1, 0, 0],
    borderColor: [1, 0, 0],
    copies,
  });
}
